import { gql } from "@apollo/client";

import {
  AskAiChatMessageFragment,
  ChatSessionMessageReactionFragment,
} from "./get-ask-ai-session-query";

export default gql`
  ${ChatSessionMessageReactionFragment}
  ${AskAiChatMessageFragment}
  mutation createAskAIMessageMutation(
    $chatSessionId: Int
    $meetingId: Int
    $assessmentId: Int
    $assessmentQuestionId: Int
    $message: String!
    $imageUrls: [String!]
    $messageId: String
    $systemContextMessage: String
  ) {
    sendMessageToChatbot(
      chatSessionId: $chatSessionId
      meetingId: $meetingId
      assessmentId: $assessmentId
      assessmentQuestionId: $assessmentQuestionId
      message: $message
      imageUrls: $imageUrls
      messageId: $messageId
      systemContextMessage: $systemContextMessage
    ) {
      chatSession {
        id
        updated
        assessment {
          id
          target {
            id
            name
          }
        }
        assessmentQuestion {
          id
          title
        }
        meeting {
          id
          title
        }
        reactions {
          edges {
            node {
              ...ChatSessionMessageReactionFragment
            }
          }
        }
        messages {
          edges {
            node {
              ...AskAiChatMessageFragment
            }
          }
        }
      }
    }
  }
`;
